import "./plantconsumption.css";
import { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import * as React from 'react';
import Moment from 'moment';
import moment from 'moment';

import { authKey, PLANT_CONSUMPTION, GET_FINANCIAL_YEAR, GET_WEEK_START_END_DATE } from '../../common/URLs';
import { loaderService } from "../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { DialogContent, Dialog, DialogActions, Divider } from '@mui/material';
import { ConfirmPopover } from '../../preregcamps/confirmPopover/confirmPopover';
import { ErrorPopover } from '../../common/ErrorPopover/errorPopover';
import { PROD } from "../../common/constants";
import { confirmAlert } from 'react-confirm-alert';
import { PlantConsumptionPopover } from "./plantCBConsumption/plantConsumptionPopover";
import { Typography, Container, Card, CardContent, Box, Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ConfirmationPopover } from "../../common/commonPopovers/confirmationPopover";
import { handleNumberFieldFocus } from "../../common/commonFunction";
import { SubmitIcon } from "../../common/icons";
import apiClient from "../../axios";

function Plantconsumption() {

  const navigate = useNavigate();

  const [fromDate, setFromDate] = useState(new Date());

  const [financialYearList, setFinancialYearList] = useState([]);
  const [getStartEndDate, setGetStartEndDate] = useState([]);
  const [getHolidayList, setGetHolidayList] = useState([]);
  const [isApiCalled, setIsApiCalled] = useState(false);


  const [plantConsumptionDetails, setPlantConsumptionDetails] = useState();

  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  const [logModalOpen1, setLogModalOpen1] = useState(false);
  const handleLogModalOpen1 = () => setLogModalOpen1(true);
  const handleLogModalClose1 = () => setLogModalOpen1(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [consumption, setConsumption] = useState({
    "date": "",
    "financialYear": "",
    "month": "",
    "planningNumber": "",
    "weekNumber": "",
    "expectedCb": "",
    "triForWeek": "",
    "expectedConsumptionQuantity1": "",
    "expectedConsumptionQuantity2": "",
    "expectedConsumptionQuantity3": "",
    "expectedConsumptionQuantity4": "",
    "expectedConsumptionQuantity5": "",
    "expectedConsumptionQuantity6": "",
    "expectedConsumptionQuantity7": ""
  });

  const [errorMessage, setErrorMessage] = useState({
    "dateError": "",
    "financialYearError": "",
    "monthError": "",
    "planningNumberError": "",
    "weekNumberError": "",
    "expectedCbError": "",
    "triForWeekError": "",
    "expectedConsumptionQuantity1Error": "",
    "expectedConsumptionQuantity2Error": "",
    "expectedConsumptionQuantity3Error": "",
    "expectedConsumptionQuantity4Error": "",
    "expectedConsumptionQuantity5Error": "",
    "expectedConsumptionQuantity6Error": "",
    "expectedConsumptionQuantity7Error": "",
  });

  const day1Consumption = false;
  const day2Consumption = false;
  const day3Consumption = false;
  const day4Consumption = false;
  const day5Consumption = false;
  const day6Consumption = false;
  const day7Consumption = false;

  const handleChange = (e) => {
    const limit = 15
    setConsumption({ ...consumption, [e.target.name]: e.target.value.slice(0, limit) });

    // if (e.target.value.length > e.target.maxLength) {
    //   e.target.value = e.target.value.slice(0, e.target.maxLength);
    // }


    if (e.target.name === "date") {
      setErrorMessage({ ...errorMessage, dateError: "" });
    }

    if (e.target.name === "financialYear") {
      setErrorMessage({ ...errorMessage, financialYearError: "" });
    }

    if (e.target.name === "month") {
      setErrorMessage({ ...errorMessage, monthError: "" });
    }
    if (e.target.name === "planningNumber") {
      setErrorMessage({ ...errorMessage, planningNumberError: "" });
    }

    if (e.target.name === "weekNumber") {
      setErrorMessage({ ...errorMessage, weekNumberError: "" });
    }

    if (e.target.name === "expectedCb") {
      setErrorMessage({ ...errorMessage, expectedCbError: "" });
    }

    if (e.target.name === "triForWeek") {
      setErrorMessage({ ...errorMessage, triForWeekError: "" });
    }

    if (e.target.name === "expectedConsumptionQuantity1") {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity1Error: "" });
    }
    if (e.target.name === "expectedConsumptionQuantity2") {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity2Error: "" });
    }
    if (e.target.name === "expectedConsumptionQuantity3") {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity3Error: "" });
    }
    if (e.target.name === "expectedConsumptionQuantity4") {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity4Error: "" });
    }
    if (e.target.name === "expectedConsumptionQuantity5") {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity5Error: "" });
    }
    if (e.target.name === "expectedConsumptionQuantity6") {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity6Error: "" });
    }
    if (e.target.name === "expectedConsumptionQuantity7") {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity7Error: "" });
    }
  };

  useEffect(() => {
    getFinancialYearApi();
  }, []);

  const getFinancialYearApi = () => {
    loaderService.showLoader();
    apiClient.post(GET_FINANCIAL_YEAR,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        setFinancialYearList(response.data?.financialYearLst);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }


  const addPlantConsumption = () => {
    loaderService.showLoader()
    let plantConsumptions = [];
    if (consumption?.expectedConsumptionQuantity1) {
      plantConsumptions.push({
        "date": date1,
        "financialYear": consumption?.financialYear,
        "month": consumption?.month,
        "planningNumber": consumption?.planningNumber,
        "weekNumber": consumption?.weekNumber,
        "expectedCb": null,
        "triForWeek": consumption?.triForWeek,
        "expectedConsumptionQuantity": consumption?.expectedConsumptionQuantity1

      })
    }
    if (consumption?.expectedConsumptionQuantity2) {
      plantConsumptions.push({
        "date": date2,
        "financialYear": consumption?.financialYear,
        "month": consumption?.month,
        "planningNumber": consumption?.planningNumber,
        "weekNumber": consumption?.weekNumber,
        "expectedCb": null,
        "triForWeek": consumption?.triForWeek,
        "expectedConsumptionQuantity": consumption?.expectedConsumptionQuantity2

      })
    }

    if (consumption?.expectedConsumptionQuantity3) {
      plantConsumptions.push({
        "date": date3,
        "financialYear": consumption?.financialYear,
        "month": consumption?.month,
        "planningNumber": consumption?.planningNumber,
        "weekNumber": consumption?.weekNumber,
        "expectedCb": null,
        "triForWeek": consumption?.triForWeek,
        "expectedConsumptionQuantity": consumption?.expectedConsumptionQuantity3

      })
    }

    if (consumption?.expectedConsumptionQuantity4) {
      plantConsumptions.push({
        "date": date4,
        "financialYear": consumption?.financialYear,
        "month": consumption?.month,
        "planningNumber": consumption?.planningNumber,
        "weekNumber": consumption?.weekNumber,
        "expectedCb": null,
        "triForWeek": consumption?.triForWeek,
        "expectedConsumptionQuantity": consumption?.expectedConsumptionQuantity4

      })
    }

    if (consumption?.expectedConsumptionQuantity5) {
      plantConsumptions.push({
        "date": date5,
        "financialYear": consumption?.financialYear,
        "month": consumption?.month,
        "planningNumber": consumption?.planningNumber,
        "weekNumber": consumption?.weekNumber,
        "expectedCb": null,
        "triForWeek": consumption?.triForWeek,
        "expectedConsumptionQuantity": consumption?.expectedConsumptionQuantity5

      })
    }

    if (consumption?.expectedConsumptionQuantity6) {
      plantConsumptions.push({
        "date": date6,
        "financialYear": consumption?.financialYear,
        "month": consumption?.month,
        "planningNumber": consumption?.planningNumber,
        "weekNumber": consumption?.weekNumber,
        "expectedCb": null,
        "triForWeek": consumption?.triForWeek,
        "expectedConsumptionQuantity": consumption?.expectedConsumptionQuantity6

      })
    }

    if (consumption?.expectedConsumptionQuantity7) {
      plantConsumptions.push({
        "date": date7,
        "financialYear": consumption?.financialYear,
        "month": consumption?.month,
        "planningNumber": consumption?.planningNumber,
        "weekNumber": consumption?.weekNumber,
        "expectedCb": null,
        "triForWeek": consumption?.triForWeek,
        "expectedConsumptionQuantity": consumption?.expectedConsumptionQuantity7

      })
    }

    apiClient
      .post(
        PLANT_CONSUMPTION,
        {
          "plantConsumptionDTODetails": plantConsumptions
        },

        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        },
        null
      )
      .then((response) => {
        setPlantConsumptionDetails(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  useEffect(() => {
    if (consumption?.financialYear && consumption?.weekNumber && consumption?.month)
      getromandToDate();
  }, [consumption?.financialYear, consumption?.month, consumption?.weekNumber]);

  const getromandToDate = () => {
    if (consumption?.month != null && consumption?.weekNumber != null && consumption?.financialYear) {


      loaderService.showLoader()
      let fiscalYear = (consumption?.financialYear).split('-')
      apiClient
        .post(
          GET_WEEK_START_END_DATE,
          {
            "year": consumption?.month === "1" || consumption?.month === "2" || consumption?.month === "3" ? fiscalYear[1] : fiscalYear[0],
            "month": consumption?.month,
            "weekNumber": consumption?.weekNumber,
            "financialYear": consumption?.financialYear
          },
          {
            headers:
            {
              Authorization: "Bearer " + getLocalStorageItem('id_token'),
            },
          },
          null
        )
        .then((response) => {
          setGetStartEndDate(response.data.weekDaysDetails);
          response.data.weekDaysDetails?.weekStartDate === null && onClickWeekNo()
          setGetHolidayList(response.data.plantHoldiday?.date);
          // setConsumption1(new Date(date.getTime() + 0 * 24 * 60 * 60 * 1000))
          // setConsumption2(new Date(date.getTime() + 1 * 24 * 60 * 60 * 1000))
          // setConsumption3(new Date(date.getTime() + 2 * 24 * 60 * 60 * 1000))
          // setConsumption4(new Date(date.getTime() + 3 * 24 * 60 * 60 * 1000))
          // setConsumption5(new Date(date.getTime() + 4 * 24 * 60 * 60 * 1000))
          // setConsumption6(new Date(date.getTime() + 5 * 24 * 60 * 60 * 1000))
          // setConsumption7(new Date(date.getTime() + 6 * 24 * 60 * 60 * 1000))
          loaderService.hideLoader();
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader();
          toast.error(error.message);
        });
    }
  };

  // const onConfirmApprove = (e) => {
  //   handleConfirmClose();
  //   addPlantConsumption();
  //   // onSubmit(e);
  // }

  const onConfirmApprove = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await addPlantConsumption();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen(false);
      setIsApiCalled(false);
    }
  };

  const onSubmitButtonClick = (e) => {
    handleConfirmOpen();
  }

  const onSubmit = (e) => {
    // if (!consumption?.expectedCb) {
    //   setErrorMessage({ ...errorMessage, expectedCbError: "Please Enter Expected CB Consumption" })
    // }
    if (!consumption?.financialYear) {
      setErrorMessage({ ...errorMessage, financialYearError: "Please Select Fiscal Year" })
    }
    else if (!consumption?.month) {
      setErrorMessage({ ...errorMessage, monthError: "Please Select Month" })
    }
    else if (!consumption?.weekNumber) {
      setErrorMessage({ ...errorMessage, weekNumberError: "Please Select Week Number" })
    }
    else if (!consumption?.planningNumber) {
      setErrorMessage({ ...errorMessage, planningNumberError: "Please Enter Planning Number" })
    }
    else if (!consumption?.triForWeek) {
      setErrorMessage({ ...errorMessage, triForWeekError: "Please Enter TRI for Scheduling Week" })
    }
    else if (process(date1) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity1 && !(holidate.includes(date1))) {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity1Error: "Please Enter Expected Consumption Quantity" })
    }
    else if (process(date2) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity2 && !(holidate.includes(date2))) {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity2Error: "Please Enter Expected Consumption Quantity" })
    }
    else if (process(date3) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity3 && !(holidate.includes(date3))) {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity3Error: "Please Enter Expected Consumption Quantity" })
    }
    else if (process(date4) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity4 && !(holidate.includes(date4))) {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity4Error: "Please Enter Expected Consumption Quantity" })
    }
    else if (process(date5) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity5 && !(holidate.includes(date5))) {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity5Error: "Please Enter Expected Consumption Quantity" })
    }
    else if (process(date6) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity6 && !(holidate.includes(date6))) {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity6Error: "Please Enter Expected Consumption Quantity" })
    }
    else if (process(date7) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity7 && !(holidate.includes(date7))) {
      setErrorMessage({ ...errorMessage, expectedConsumptionQuantity7Error: "Please Enter Expected Consumption Quantity" })
    }
    else {
      onSubmitButtonClick();
      // addPlantConsumption();
    }
  }
  useEffect(() => {
    if (plantConsumptionDetails) {
      if (plantConsumptionDetails.isSuccess === true) {
        toast.success(plantConsumptionDetails?.message)
        navigate('/plantSchedule', { state: { planningNumber: consumption?.planningNumber, weekNumber: consumption?.weekNumber, month: consumption?.month } })
        // handleLogModalOpen1();
      }
      else {
        toast.error(plantConsumptionDetails?.message ? plantConsumptionDetails?.message : "Error")
        // handleLogModalOpen();
      }
    }
  }, [plantConsumptionDetails]);


  const date1 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(0, 'days').format('YYYY-MM-DD')
  const date2 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(1, 'days').format('YYYY-MM-DD')
  const date3 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(2, 'days').format('YYYY-MM-DD')
  const date4 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(3, 'days').format('YYYY-MM-DD')
  const date5 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(4, 'days').format('YYYY-MM-DD')
  const date6 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(5, 'days').format('YYYY-MM-DD')
  const date7 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(6, 'days').format('YYYY-MM-DD')
  const enddateFormat = getStartEndDate?.weekEndDate && Moment(getStartEndDate?.weekEndDate).format('YYYY-MM-DD')

  const holidate = getHolidayList.map((date) => {
    return moment(moment(date)).format('YYYY-MM-DD');
  });



  const process = (date) => {

    if (date) {

      var parts = date?.split("-");

      return new Date(parts[0], parts[1] - 1, parts[2]);

    }

  }

  const onClickWeekNo = (onClose) => {
    // confirmAlert({
    //   customUI: ({ onClose }) => {
    //     return (
    //       <PlantConsumptionPopover onClose={onClose} />
    //     );

    //   }

    // });
    handleLogModalOpen(onClose);
  }

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT20</p>}
        <Typography variant="h5" gutterBottom>
          Plant Consumption Schedule
        </Typography>
        <Card>
          <CardContent>
            <Grid container spacing={1} direction="row" mt={1}>
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth size="small" required error={errorMessage.financialYearError}>
                      <InputLabel>Fiscal Year</InputLabel>
                      <Select label='Fiscal Year' name="financialYear" onChange={(e) => handleChange(e)}>
                        <MenuItem value="select" selected >Fiscal year</MenuItem>
                        {financialYearList && financialYearList?.map((item) =>
                          <MenuItem value={item}>{item}</MenuItem>

                        )}

                      </Select>
                      <FormHelperText sx={{ color: 'red' }}> {errorMessage.financialYearError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth size="small" required error={errorMessage.monthError}>
                      <InputLabel>Month</InputLabel>
                      <Select label="Month" name="month" onChange={(e) => handleChange(e)}>
                        <MenuItem selected>Months</MenuItem>
                        <MenuItem value="1">January</MenuItem>
                        <MenuItem value="2">February</MenuItem>
                        <MenuItem value="3">March</MenuItem>
                        <MenuItem value="4">April</MenuItem>
                        <MenuItem value="5">May</MenuItem>
                        <MenuItem value="6">June</MenuItem>
                        <MenuItem value="7">July</MenuItem>
                        <MenuItem value="8">August</MenuItem>
                        <MenuItem value="9">September</MenuItem>
                        <MenuItem value="10">October</MenuItem>
                        <MenuItem value="11">November</MenuItem>
                        <MenuItem value="12">December</MenuItem>
                      </Select>
                      <FormHelperText sx={{ color: 'red' }}> {errorMessage.monthError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth size="small" required error={errorMessage.weekNumberError}>
                      <InputLabel>Week Number</InputLabel>
                      <Select label="Week Number" name="weekNumber" onChange={(e) => handleChange(e)}>
                        <MenuItem value="select" selected>Week Number</MenuItem>
                        <MenuItem value="1">1</MenuItem>
                        <MenuItem value="2">2</MenuItem>
                        <MenuItem value="3">3</MenuItem>
                        <MenuItem value="4">4</MenuItem>
                        <MenuItem value="5">5</MenuItem>
                        <MenuItem value="6">6</MenuItem>
                      </Select>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.weekNumberError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Schedule From"
                          inputFormat="DD/MM/YYYY"
                          name="date"
                          value={getStartEndDate?.weekStartDate}
                          disabled
                          // onChange={(e) => { handleDateChange(e) }}
                          renderInput={(params) => <TextField size="small" {...params} />}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Schedule To"
                          inputFormat="DD/MM/YYYY"
                          name="pickUpToDate"
                          value={getStartEndDate?.weekEndDate}
                          disabled
                          renderInput={(params) => <TextField size="small" {...params} />}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" required
                      error={errorMessage.triForWeekError}
                      helperText={errorMessage.triForWeekError}
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      name="triForWeek"
                      value={consumption?.triForWeek}
                      label="TRI for Scheduling Week"
                      onChange={(e) => handleChange(e)}
                      onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" required
                      error={errorMessage.planningNumberError}
                      helperText={errorMessage.planningNumberError}
                      type="text"
                      name="planningNumber"
                      label="Planning Number"
                      onChange={(e) => handleChange(e)}
                      value={consumption?.planningNumber}
                      onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === ',' || evt.key === '.' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                    />
                  </Grid>

                </Grid>
              </Grid>
              <Divider sx={{
                width: '105%',
                bgcolor: 'black',
                marginTop: '3vh'
              }} mt={2} />
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <>
                    {getStartEndDate?.weekStartDate &&
                      <>
                        <Grid item xs={12} lg={12}>
                          <Typography variant="h6" gutterBottom>
                            Expected Consumption
                          </Typography>
                        </Grid>
                        {process(date1) <= process(enddateFormat) && !(holidate.includes(date1)) ?
                          <Grid item xs={12} lg={4}>
                            {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                            <TextField fullWidth required size="small"
                              error={errorMessage.expectedConsumptionQuantity1Error}
                              helperText={errorMessage.expectedConsumptionQuantity1Error}
                              type="number"
                              onFocus={handleNumberFieldFocus}
                              name="expectedConsumptionQuantity1"
                              value={consumption.expectedConsumptionQuantity1}
                              label={'Day' + ' ' + (date1 && Moment(date1).format('DD/MM/YYYY'))}
                              onChange={(e) => handleChange(e)}
                              day1Consumption={true}
                              onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                            />

                          </Grid>
                          : null
                        }
                        {process(date2) <= process(enddateFormat) && !(holidate.includes(date2)) ?
                          <Grid item xs={12} lg={4}>
                            {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                            <TextField fullWidth required size="small"
                              error={errorMessage.expectedConsumptionQuantity2Error}
                              helperText={errorMessage.expectedConsumptionQuantity2Error}
                              type="number"
                              onFocus={handleNumberFieldFocus}
                              name="expectedConsumptionQuantity2"
                              value={consumption.expectedConsumptionQuantity2}
                              label={'Day' + ' ' + (date2 && Moment(date2).format('DD/MM/YYYY'))}
                              onChange={(e) => handleChange(e)}
                              day1Consumption={true}
                              onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                            />

                          </Grid>
                          : null
                        }
                        {process(date3) <= process(enddateFormat) && !(holidate.includes(date3)) ?
                          <Grid item xs={12} lg={4}>
                            {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                            <TextField fullWidth required size="small"
                              error={errorMessage.expectedConsumptionQuantity3Error}
                              helperText={errorMessage.expectedConsumptionQuantity3Error}
                              type="number"
                              onFocus={handleNumberFieldFocus}
                              name="expectedConsumptionQuantity3"
                              value={consumption.expectedConsumptionQuantity3}
                              label={'Day' + ' ' + (date3 && Moment(date3).format('DD/MM/YYYY'))}
                              onChange={(e) => handleChange(e)}
                              day1Consumption={true}
                              onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                            />

                          </Grid>
                          : null
                        }
                        {process(date4) <= process(enddateFormat) && !(holidate.includes(date4)) ?
                          <Grid item xs={12} lg={4}>
                            {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                            <TextField fullWidth required size="small"
                              error={errorMessage.expectedConsumptionQuantity4Error}
                              helperText={errorMessage.expectedConsumptionQuantity4Error}
                              type="number"
                              onFocus={handleNumberFieldFocus}
                              name="expectedConsumptionQuantity4"
                              value={consumption.expectedConsumptionQuantity4}
                              label={'Day' + ' ' + (date4 && Moment(date4).format('DD/MM/YYYY'))}
                              onChange={(e) => handleChange(e)}
                              day1Consumption={true}
                              onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                            />

                          </Grid>
                          : null
                        }
                        {process(date5) <= process(enddateFormat) && !(holidate.includes(date5)) ?
                          <Grid item xs={12} lg={4}>
                            {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                            <TextField fullWidth required size="small"
                              error={errorMessage.expectedConsumptionQuantity5Error}
                              helperText={errorMessage.expectedConsumptionQuantity5Error}
                              type="number"
                              onFocus={handleNumberFieldFocus}
                              name="expectedConsumptionQuantity5"
                              value={consumption.expectedConsumptionQuantity5}
                              label={'Day' + ' ' + (date5 && Moment(date5).format('DD/MM/YYYY'))}
                              onChange={(e) => handleChange(e)}
                              day1Consumption={true}
                              onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                            />

                          </Grid>
                          : null
                        }
                        {process(date6) <= process(enddateFormat) && !(holidate.includes(date6)) ?
                          <Grid item xs={12} lg={4}>
                            {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                            <TextField fullWidth required size="small"
                              error={errorMessage.expectedConsumptionQuantity6Error}
                              helperText={errorMessage.expectedConsumptionQuantity6Error}
                              type="number"
                              onFocus={handleNumberFieldFocus}
                              name="expectedConsumptionQuantity6"
                              value={consumption.expectedConsumptionQuantity6}
                              label={'Day' + ' ' + (date6 && Moment(date6).format('DD/MM/YYYY'))}
                              onChange={(e) => handleChange(e)}
                              day1Consumption={true}
                              onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}

                            />

                          </Grid>
                          : null
                        }
                        {process(date7) <= process(enddateFormat) && !(holidate.includes(date7)) ?
                          <Grid item xs={12} lg={4}>
                            {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                            <TextField fullWidth required size="small"
                              error={errorMessage.expectedConsumptionQuantity7Error}
                              helperText={errorMessage.expectedConsumptionQuantity7Error}
                              type="number"
                              onFocus={handleNumberFieldFocus}
                              name="expectedConsumptionQuantity7"
                              value={consumption.expectedConsumptionQuantity7}
                              label={'Day' + ' ' + (date7 && Moment(date7).format('DD/MM/YYYY'))}
                              onChange={(e) => handleChange(e)}
                              day1Consumption={true}
                              onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}

                            />

                          </Grid>
                          : null
                        }

                      </>
                    }

                  </>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>

        </Card>

        <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
          <Button endIcon={<SubmitIcon />} sx={{ minWidth: 100 }} variant="contained" type='submit' onClick={(e) => onSubmit(e)}>Submit</Button>
        </Box>
      </Container>

      <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Submit" />

      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <PlantConsumptionPopover handleLogModalClose={handleLogModalClose} />
        </DialogContent>
      </Dialog>
      {/* <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <ConfirmPopover title={plantConsumptionDetails?.message} hideLink={true} />    </DialogContent>
        <DialogActions>
          <Button onClick={() => { navigate('/plantSchedule', { state: { planningNumber: consumption?.planningNumber, weekNumber: consumption?.weekNumber } }); handleLogModalClose() }}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen1}>
        <DialogContent>
          <ErrorPopover title={plantConsumptionDetails?.message ? plantConsumptionDetails?.message : "Error"} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose1}>OK</Button>
        </DialogActions>
      </Dialog> */}
    </>
  )
}
export default Plantconsumption;